import { RefreshIcon, SalesIcon } from "../../../../assets/icons";
import styles from "./DashboardCard.module.scss";

export enum DashboardCardTypes {
    YELLOW_CARD = 'yellowcard',
    GREEN_CARD = "greencard",
    BLUE_CARD = "bluecard",
    LIGHT_BLUE_CARD = "lightbluecard",
    RED_CARD = "redcard",
    ORANGE_CARD = "orangecard",
}

interface DashboardCardProps {
    title: string;
    amount: string;
    icon: React.ReactNode;
    refreshIcon?: React.ReactNode;
    className: DashboardCardTypes
}
export const DashboardCard = ({title, amount, icon, refreshIcon, className }: Readonly<DashboardCardProps>) => {
	return (
		<div className={`${styles.dashboardCard} ${className}`}>
			<div className={styles.content}>
				<div className={styles.leftSection}>
					<span className={styles.title}>{title}</span>
					<h3 className={styles.amount}>{amount}</h3>
				</div>
				<div className={styles.rightSection}>
					{icon}
					{refreshIcon}
				</div>
			</div>
		</div>
	);
};
